/**
 * 提现记录列表
 **/


import React from 'react';
import {connect} from 'react-redux';
import {Button, Card, Col, Form, message, Modal, Popconfirm, Spin, Tag} from "antd";
import {createUserAddress, deleteUserAddress, findUserAddress, letUserAddressIsDefault, updateUserAddress} from "../../services/user";
import styled from "styled-components";
import {bindActionCreators} from "redux";
import {fetchUserAddresses} from "../../redux/actions/userAddress";
import UserAddressForm from "./UserAddressForm";


const AddressesBookDiv = styled.div`
    .ant-form-item {
      margin-bottom: 0
    }
    
    .addrbook-tools{
      z-index: 100;
      position: absolute;
      right:11px;
      top:11px;
      a+a {
        margin-left: 8px;
        margin-bottom: 0;
      }
    }
`

const formItemLayout1 = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 6},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 18},
    },
};

const formItemLayout2 = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 3},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 21},
    },
};


class UserAddressesSetting extends React.Component {

    constructor(props) {
        super(props);
        this.userAddressCreateForm = null;
        this.userAddressModifyForm = null;
        this.addr = null;
        this.state = {
            userAddressCreateFormModalVisible: false,
            userAddressModifyFormModalVisible: false,
        }
    }


    componentDidMount() {
        if (!this.props.userAddresses) {
            this.fetchData();
        }
    }

    fetchData = (callback) => {
        this.props.fetchUserAddresses({userId: this.props.userId}).then(()=>{
            if(callback)
                callback();
        });
    }


    componentWillReceiveProps(nextProps) {

    }

    resetFormFields = () => {
        this.props.form.resetFields();
    }

    submitLetUserAddressIsDefault = (addrId) => {
        letUserAddressIsDefault({userId: this.props.userId, addressId: addrId}).then(res => {
            if (res.code == 200) {
                message.info("设为默认成功! ");
                this.props.fetchUserAddresses({userId: this.props.userId});
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    submitDeleteUserAddress = (addrId) => {
        deleteUserAddress({userId: this.props.userId, addressId: addrId}).then(res => {
            if (res.code == 200) {
                message.info("删除成功! ");
                this.props.fetchUserAddresses({userId: this.props.userId});
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }


    showCreateModel = () => {
        this.setState({
            userAddressCreateFormModalVisible: true,
        })
    }
    showModifyModel = (addrId) => {
        findUserAddress({userId: this.props.userId,addressId: addrId}).then(res => {
            if (res.code == 200) {
                this.addr = res.data;
                this.setState({
                    userAddressModifyFormModalVisible: true,
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    handleCancel = () => {
        this.setState({
            userAddressModifyFormModalVisible: false,
            userAddressCreateFormModalVisible: false,
        });

    }

    render() {

        return (
            <Spin spinning={this.props.userAddresses.isFetching}>
                <div>
                    <Button type="primary" ghost size="small" style={{marginBottom:7}} onClick={(e) => {
                        this.showCreateModel();
                    }}>新增地址</Button>

                    <AddressesBookDiv>
                        {
                            this.props.userAddresses.data.map((addr, index) => {
                                return (
                                    <Card bodyStyle={{padding: "7px 15px"}} key={`addrs-sdfsdf-${addr.id}-${index}`}>
                                        <div className="addrbook-tools">
                                            <div>
                                                {
                                                    addr.defaulted ? null : <a href="#" onClick={(e) => {
                                                        e.preventDefault();
                                                        this.submitLetUserAddressIsDefault(addr.id);
                                                    }}>
                                                        设为默认
                                                    </a>
                                                }

                                                <a onClick={(e) => {
                                                    e.preventDefault();
                                                    this.showModifyModel(addr.id);
                                                }}>编辑</a>
                                                <Popconfirm title={<span>您确定要设置为删除吗吗?</span>}
                                                            placement="left"
                                                            onConfirm={(e) => {
                                                                e.preventDefault();
                                                                this.submitDeleteUserAddress(addr.id);
                                                            }}
                                                            okText="删除"
                                                            cancelText="放弃">
                                                    <a href="#">删除</a>
                                                </Popconfirm>
                                            </div>
                                        </div>
                                        <Col span={24}>
                                            <Form.Item
                                                {...formItemLayout2}
                                                label="收货人"
                                            >
                                                <span>{addr.recipientName}</span>
                                                <span>
                                                    {
                                                        addr.defaulted ?
                                                            <Tag color="#108ee9" style={{marginLeft: "10px"}}>默认</Tag> : null

                                                    }
                                                </span>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                {...formItemLayout2}
                                                label="所在地区"
                                            >
                                                <span>{addr.province}{addr.city}{addr.subCity}</span>
                                            </Form.Item>
                                        </Col>
                                        {/* <Col span={12}>
                                    <Form.Item
                                        {...formItemLayout1}
                                        label="所在街道"
                                    >
                                        <span>{addr.street}</span>
                                    </Form.Item>
                                </Col>*/}
                                        <Col span={24}>
                                            <Form.Item
                                                {...formItemLayout2}
                                                label="地址"
                                            >
                                                <span>{addr.location}</span>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                {...formItemLayout1}
                                                label="联系电话"
                                            >
                                                <span>{addr.recipientPhone}</span>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                {...formItemLayout1}
                                                label="邮编"
                                            >
                                                <span>{addr.postalCode}</span>
                                            </Form.Item>
                                        </Col>


                                    </Card>
                                )
                            })
                        }

                    </AddressesBookDiv>

                </div>

                <Modal
                    visible={this.state.userAddressModifyFormModalVisible}
                    title={`编辑收货地址`}
                    width="600px"
                    maskClosable={false}
                    onCancel={this.handleCancel}
                    destroyOnClose={true}
                    footer={null}
                >
                    {
                        this.state.userAddressModifyFormModalVisible?
                        <UserAddressForm
                            wrappedComponentRef={(comp) => this.userAddressModifyForm = comp}
                            userId={this.props.userId}
                            addr={this.addr}
                            submitServiceFunc={updateUserAddress}
                            submitSuccessCallback={() => {
                                this.fetchData(()=>{ this.handleCancel()});

                            }}
                            cancelCallback={this.handleCancel}
                        />:null

                    }


                </Modal>

                <Modal
                    visible={this.state.userAddressCreateFormModalVisible}
                    title={`新增收货地址`}
                    width="600px"
                    maskClosable={false}
                    afterClose={() => this.userAddressCreateForm.resetFormFields()}
                    onCancel={this.handleCancel}
                    destroyOnClose={true}
                    footer={null}
                >
                    {
                        <UserAddressForm
                            wrappedComponentRef={(comp) => this.userAddressCreateForm = comp}
                            userId={this.props.userId}
                            submitServiceFunc={createUserAddress}
                            submitSuccessCallback={() => {
                                this.fetchData(()=>{ this.handleCancel()});
                            }}
                            cancelCallback={this.handleCancel}
                        />

                    }


                </Modal>

            </Spin>
        )
    }
}


UserAddressesSetting.contextTypes = {};

UserAddressesSetting.defaultProps = {
    userId: null,
    userAddresses: null,
    submitSuccessCallback: null,
    cancelCallback: null,
};

UserAddressesSetting.propTypes = {}

const mapStateToPorps = state => {
    const userAddresses = state.userAddresses;
    const {lastLocation} = state.global;
    const cmEnums = state.cmEnums;
    return {lastLocation, cmEnums, userAddresses};
};
const mapDispatchToProps = dispatch => ({
    fetchUserAddresses: bindActionCreators(fetchUserAddresses, dispatch),
});


export default connect(mapStateToPorps, mapDispatchToProps)(UserAddressesSetting);




// WEBPACK FOOTER //
// ./src/containers/user/UserAddressesSetting.jsx